<template>
    <section class="ourteam__container">
        <div class="team_wrapper">
            <div class="team_member">
                <img src="https://d3f86pfw66amx.cloudfront.net/uncode/wp-content/uploads/2015/03/shutterstock_159780776-uai-1032x688.jpg">
                <span class="team_name">Ola Nordmann</span>
                <span class="team_title">Daglig leder</span>
                <span class="team_text"></span>
                <span class="team_mail"><a href="/">ola@kreatif.no</a></span>
                <span class="team_phone">999 99 999</span>
            </div>
        </div>
    </section>
</template>
<script>
import Vue from 'vue';

export default Vue.extend({
	props: {
		post: {
			type: Object,
			required: true,
		},
	},
});
</script>